class InputValidator {
  static isValidEmail(input) {
    input = input.trim();
    const emailRegex = /^[a-zA-Z0-9.]+@(gmail|yahoo)+\.(com|in)$/;
    if (input === "") {
      return "Email should not be empty.";
    } else if (!emailRegex.test(input)) {
      return "Invalid email format.";
    } else {
      return "";
    }
  }

static isValidPassport(input) {
  input = input.trim();
  const passportRegex = /^[A-Z]{1}[0-9]{7}$/;

  if (input === "") {
    return "Passport number should not be empty.";
  } else if (!passportRegex.test(input.toUpperCase())) {
    return "Valid Passport Format (e.g., A1234567)";
  } else {
    return "";
  }
}


  static isValidLoginEmail(input) {
    input = input.trim();
    const emailRegex = /^[^\s@]+@nucleusteq\.com$/;
    if (input === "") {
      return "Email should not be empty.";
    } else if (!emailRegex.test(input)) {
      return "Invalid email format.";
    } else {
      return "";
    }
  }

  static isValidPassword(input) {
    input = input.trim();
    if (input === "") {
      return "Password should not be empty.";
    } else if (input.length < 8) {
      return 'Password should have atleast 8 characters.'
    } else {
      return "";
    }
  }

  static isEmpty(input) {
    input = input ? input.toString() : '';
    input = input ? input?.trim() : '';
    if (input === "" ||input ==="0") {
      return "Field should not be empty.";
    } else {
      return "";
    }
  }

  static isArrayEmpty(input) {
    if (input && input.length === 0) {
      return true;
    } else {
      return false;
    }
  }

  static isCompanyName(input){
    const regex = /^[a-zA-Z0-9&.,'-]+(?: [a-zA-Z0-9&.,'-]+)*$/;
    if (!regex.test(input)) {
        return "Company Name should not have Spaces" ; 
    } 
    return "";
  }
  

  static isNull(input) {
    if (input === null) {
      return true;
    } else {
      return false;
    }
  }

  static isObjectEmpty(obj) {
    for (const key in obj) {
      if (obj[key] === null || obj[key] === "" || obj[key] === undefined) {
        return true;
      }
    }
    return false;
  }
  static isPanNumber(input) {
    input = input.trim();
    const panRegex = /^[A-Z]{5}[0-9]{4}[A-Z]{1}$/;
    if (input === "") return "Pan should not be empty.";
    if (input.length < 10) return "Pan Number should be 10 characters";
    if (!panRegex.test(input)) return "Invalid Pan format.";

    return "";
  }
  static isValidAadhaar(input) {
    input = input.trim();
    const aadhaarRegex = /^[2-9]{1}[0-9]{11}$/;

    if (input.length !== 12) {
      return "Aadhaar Number must be exactly 12 digits.";
    }
    if (!aadhaarRegex.test(input)) {
      return "cannot start with 0 ,1,E/e,-,+..";
    }
    return "";
  }

  static isValidPassport(input) {
    
    if (!input) return ""; 
    input = input.toString().trim().toUpperCase();
    const passportRegex = /^[A-Z]{1}[0-9]{7}$/;
    if (!passportRegex.test(input)) {
      return "Invalid Passport Format (e.g., A1234567)";
    }
    return "";
  }
  static isValidWorkAuthNumber(input) {
    if (!input) return ""; 
    input = input.toString().trim();
    const workAuthRegex = /^[a-zA-Z0-9]{8,20}$/;
    if (!workAuthRegex.test(input)) {
      return "Must be 8-20 character(e.g., WAC1234567890)";
    }
    return "";
  }

  
  

  static isFormErrorEmpty(formError) {
    return Object.values(formError).every((value) => value === "");
  }
  static validNamingField(input){
    input = input.trim();
    const regex = /^[a-zA-Z]+$/;
    if (!regex.test(input)) {
        return "The name must contain only letters and cannot include spaces."; 
    } else {
        return "";
    }
  }

  static isValidPhoneNumber(input) {
    let value = (input ?? "").toString().trim();

    // Empty check
    if (value === "") {
      return "Phone number should not be empty.";
    }

    // Remove spaces, hyphens, brackets for flexible input like +91 98765-43210
    value = value.replace(/[()\s-]/g, "");

    // Allow optional leading +, rest must be digits
    if (!/^\+?\d+$/.test(value)) {
      return "Phone number should contain only digits and an optional leading +.";
    }

    // Strip leading + for easier processing
    let normalized = value.startsWith("+") ? value.slice(1) : value;

    let countryCode = "";
    let nationalNumber = "";

    if (normalized.startsWith("91")) {
      countryCode = "91";
      nationalNumber = normalized.slice(2);
    } else if (normalized.startsWith("44")) {
      countryCode = "44";
      nationalNumber = normalized.slice(2);
    } else if (normalized.startsWith("1")) {
      countryCode = "1"; 
      nationalNumber = normalized.slice(1);
    } else {
      return "Unsupported country code. Allowed: +1, +44, +91.";
    }

    switch (countryCode) {
      case "91":
        if (nationalNumber.length !== 10) {
          return "India phone number must be exactly 10 digits after +91.";
        }
        if (!/^[6-9]/.test(nationalNumber)) {
          return "India mobile number should start with digits 6–9.";
        }
        break;

      case "1":
        if (nationalNumber.length !== 10) {
          return "US/Canada phone number must be exactly 10 digits after +1.";
        }
        break;

      case "44":
        if (nationalNumber.length < 10 || nationalNumber.length > 11) {
          return "UK phone number must be 10 or 11 digits after +44.";
        }
        break;

      default:
        return "Invalid or unsupported country code.";
    }

  return "";
}
}

export default InputValidator;